import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    bannerContainer: {
        paddingHorizontal: 16,
        paddingTop: 16
    },
    searchContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    searchInputContainer: {
        flex: 1
    },
    sectionHeaderContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    categoryItemContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    emptyContentContainer: {
        flex: 1
    },
    emptyNewsContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    emptyNewsText: {
        textAlign: "center"
    },
    sheetHeaderContainer: {
        alignItems: "center"
    },
    paginationContainer: {
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        alignSelf: "center",
        width: "50%"
    },
    companiesContainer: {
        alignSelf: "center"
    },
    categorySeparator: {
        alignSelf: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    paginationInactiveDot: {
    },
    categoryButton: {
        justifyContent: "center"
    },
    headerContent: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    paginationDot: {
        borderRadius: 5,
        height: 10,
        width: 10
    },
    iconContent: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    notificationButton: {
        position: "relative"
    },
    notificationBadge: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        minWidth: 16,
        right: -6,
        height: 16,
        top: -4
    },
    badgeText: {
        textAlign: "center"
    },
    flex1: {
        flex: 1
    },
    fullWidthContainer: {
        alignSelf: "center"
    },
    allButtonContainer: {
        paddingLeft: 16,
        paddingTop: 8,
        paddingBottom: 8
    },
    categorySeparatorLine: {
        width: 1
    },
    featuredScrollView: {
        flexGrow: 0
    }
});
export default stylesheet;
